module.exports = __webpack_public_path__ + "static/media/HCMM472.26b99987.jpg";